import * as firebase from "firebase/app"
import * as moment from "moment"

import { TrDateFilter } from "@tr/models"
import { TrDatePipe } from "@tr/pipes"

export function ordinalSuffixOf(day: number): string {
  const j = day % 10
  const k = day % 100
  if (j === 1 && k !== 11) {
    return `${day}st`
  }
  if (j === 2 && k !== 12) {
    return `${day}nd`
  }
  if (j === 3 && k !== 13) {
    return `${day}rd`
  }
  return `${day}th`
}

export function getCurrentTimestamp(): firebase.firestore.FieldValue {
  return firebase.firestore.FieldValue.serverTimestamp()
}

export function getDuration(startTime: any, endTime: any): moment.Duration {
  return moment.duration(Math.abs(moment(TrDatePipe.toDate(startTime)).diff(TrDatePipe.toDate(endTime))))
}

export function hasMatchingColumnByDate(columnValue: Date, dateFilter: TrDateFilter): boolean {
  const columnMoment = moment(TrDatePipe.toDate(columnValue))
  if (!columnMoment.isValid() && dateFilter.notEqualTo) {
    return false
  }

  if (dateFilter.equalTo) {
    return columnMoment.isValid() && columnMoment.isSame(dateFilter.equalTo, "day")
  } else if (dateFilter.notEqualTo) {
    return columnMoment.isValid() && !columnMoment.isSame(dateFilter.notEqualTo, "day")
  } else if (dateFilter.greaterThan) {
    return columnMoment.isAfter(dateFilter.greaterThan, "day")

  } else if (dateFilter.lessThan) {
    return columnMoment.isBefore(dateFilter.lessThan, "day")

  } else if (dateFilter.between) {
    if (dateFilter.between.inclusive) {
      return columnMoment.isSameOrAfter(dateFilter.between.after, "day")
          && columnMoment.isSameOrBefore(dateFilter.between.before, "day")

    } else {
      return columnMoment.isAfter(dateFilter.between.after, "day")
          && columnMoment.isBefore(dateFilter.between.before, "day")
    }
  }

  return false
}

export function hasMatchingColumnByDropdown(columnValue: string[], dropdownFilter: string[]): boolean {
  return dropdownFilter
    .filter(value => columnValue.includes(value))
    .length === dropdownFilter.length
}

export function hasMatchingColumnByCheckbox(columnValue: string | boolean, checkboxValue: boolean): boolean {
  if (checkboxValue === undefined) {
    return true
  }

  return checkboxValue === columnValue
}
